import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs as defaultFaqs } from '../data/content';
import type { FaqItem } from '../data/content';
interface FaqProps {
  faqs?: FaqItem[];
}
export function Faq({
  faqs = defaultFaqs
}: FaqProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="tint" title="Preguntas frecuentes" data-id="element-58" data-mp="2dzem3l5017jf">
      <ul className="mx-auto max-w-4xl space-y-3" data-id="element-59" data-mp="2dy3grgvwnrq7">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-blue-100" data-id="element-60" data-mp="240yuzi5z1y9x" data-mpi={index}>
              <h3 data-id="element-61" data-mp="smv26fb4eg6g">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-200 md:px-7" data-id="element-62" data-mp="snd7s2joa6r1">
                  <span className="text-lg font-extrabold tracking-tight text-slate-900" data-id="element-63" data-mp="fiyqbusfpu3q">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-blue-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-64" data-mp="6rgbbn785kc8" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-65" data-mp="1s3q16w04lbr">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-66" data-mp="1q0opqpef5rq">
                    <p className="px-5 pb-6 text-lg text-blue-900/75 md:px-7" data-id="element-67" data-mp="1pp352bb9zgck">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}